import { deleteUser as firebaseDeleteUser } from 'firebase/auth';

import { firebaseAuth } from 'lib/firebase/firebase.client';

import { createAuthStoreAsyncAction } from '../utils/createAuthStoreAsyncAction';

export const deleteUser = createAuthStoreAsyncAction(async () => {
  return await firebaseDeleteUser(firebaseAuth.currentUser!);
});
